import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
import { constants } from '../../utitlity/constant';

@Component({
    selector: 'ntb-email',
    template: require('./email.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EmailFieldComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() questions: any = [];
    @Input() form: NgForm;
    validationRule: any = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$'
    // @Input() prefillData: any;
    fieldModel: any;
    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    isLeadFormApplication: boolean;

    constructor() { }
    ngOnInit() {
        this.isLeadFormApplication = constants.IS_LEAD_FORM_APPLICATION;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/email/email.component.ts